import { MarginWrapper } from "src/website-apps/responsive/stubhub-home/components/connect-to-spotify/MarginWrapper";
import { SpotifyConnectProvider } from "src/website-apps/responsive/stubhub-home/components/connect-to-spotify/SpotifyConnectProvider";
import { TopSpotifyArtistCarousel } from "src/website-apps/responsive/stubhub-home/components/connect-to-spotify/TopSpotifyArtistCarousel";

/**
 * Spotify Connect on Home Page Wrapper
 */
export const SpotifyCarouselOnHome = ({ connectUrl, isSpotifyConnected, options, size }) => (
  <SpotifyConnectProvider spotifyAccountConnected={isSpotifyConnected || !connectUrl} connectSpotifyUrl={connectUrl}>
    <MarginWrapper>
      <TopSpotifyArtistCarousel initItems={options} size={size} />
    </MarginWrapper>
  </SpotifyConnectProvider>
);
